module.exports = __webpack_public_path__ + "img/img_gallery3.7988eeaa.png";